import { useRef, useCallback, useEffect } from "react";

export function useDebounce(callback, delay) {
  const callbackRef = useRef(callback);
  // use mutable ref to make useCallback/throttle not depend on `callback` dep
  useEffect(() => {
    callbackRef.current = callback;
  });
  return useCallback(
    debounce((...args) => callbackRef.current(...args), delay),
    [delay],
  );
}

export function debounce(callback, delay) {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    const later = function () {
      timeout = null;
      callback.apply(context, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, delay);
  };
}

export function calculateResults(treesponse) {
  // INFO:
  // Logic in detail: https://docs.google.com/document/d/1jgD43l8ioPNQGaXB_iyh-W1kaZOrN_2A
  // Stu_BB_SP_1 =   vraag1
  // Stu_IN_3    =   vraag2
  // Stu_TD_3    =   vraag3
  // Stu_ExpC_1  =   vraag4
  // Stu_Expl_2  =   vraag5
  // Stu_EXPF_2  =   vraag6
  const { vraag1, vraag2, vraag3, vraag4, vraag5, vraag6 } = treesponse.answers;
  if (vraag5 >= 3) return 5;

  if (vraag3 < 3) {
    if (vraag1 >= 3.5) return 4;

    return vraag4 >= 3 ? 4 : 3;
  }

  if (vraag3 >= 3) {
    if (vraag1 >= 2.5) {
      if (vraag4 < 3) {
        if (vraag6 >= 4) {
          return vraag1 < 3.5 ? 1 : 4;
        } else if (vraag6 < 4) {
          return vraag2 < 4 ? 4 : 2;
        }
      } else if (vraag4 >= 3) {
        if (vraag6 >= 4 || vraag5 >= 2) return 2;

        if (vraag5 < 2) {
          if (vraag2 < 2) return 4;
          if (vraag2 >= 2) {
            if (vraag1 >= 3.5) {
              return 2;
            } else if (vraag1 < 3.5) {
              return vraag2 < 3 ? 4 : 2;
            }
          }
        }
      }
    } else if (vraag1 < 2.5) {
      if (vraag6 < 2) return 3;
      if (vraag6 >= 2) {
        if (vraag4 >= 4) {
          if (vraag6 >= 4) return 2;
          if (vraag6 < 4) {
            return vraag3 < 4 ? 5 : 2;
          }
        } else if (vraag4 < 4) {
          if (vraag3 < 4) {
            if (vraag4 >= 2) return 1;
            if (vraag4 < 2) {
              if (vraag2 < 2) return 3;
              if (vraag2 >= 2) {
                return vraag6 < 3 ? 3 : 1;
              }
            }
          } else if (vraag3 >= 4) {
            return vraag2 < 4 ? 1 : 2;
          }
        }
      }
    }
  }
}
